import { useQuery } from "react-query";
import { fetchPatientStudies } from "@/services/studies";
/** Query hook for a patient's imaging studies. */
export function usePatientStudies(patientUid) {
  return useQuery(["patient-studies", patientUid], function () {
    return fetchPatientStudies(patientUid);
  }, {
    enabled: Boolean(patientUid)
  });
}